import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import axios from "../../axios";
import Header from "../../Layout/Header/Header";
import Controls from "../../Components/Controls/Controls";

const TreffenDetails = (props) => {
  const { id } = useParams();
  const [detaills, setDetaills] = useState({});

  useEffect(() => {
    axios
      .get(`/collections/get/meetings?filter[_id]=${id.split("-")[1]}`)
      .then((res) => {
        setDetaills(res.data.entries[0]);
      });
  }, [id]);

  return (
    <div>
      <Header small={true} />
      <main>
        <Controls to="/treffen" />
        <div dangerouslySetInnerHTML={{ __html: detaills.text }}></div>
      </main>
    </div>
  );
};

export default TreffenDetails;
